import { Box, withStyles, Icon } from "@material-ui/core";
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";
import React, { useRef } from "react";
import { IconButton } from "../../../components/IconButton";
import { hoverColor } from "../utils/configuration";
import { parseIcon } from "../utils/iconMapping";
const Label = withStyles({
    root: {
        cursor: "pointer",
        borderRadius: 8,
        fontSize: 14,
        padding: "4px 8px 4px 10px",
        transition: "all 150ms ease-in-out",
        display: "flex",
        whiteSpace: "nowrap",
        gap: "8px",
        height: "100%",
        alignItems: "center",
        position: "relative",
        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
        "&:focus": { outline: 0 },
    },
})(Box);
const labelWithoutIconOverrides = { paddingLeft: 34 };
const selectedOverrides = { background: hoverColor };
const TopMenuLabel = ({ icon: iconUnparsed, title, hidden, selected, onMouseEnter, onClick, containerRef, id, }) => {
    const icon = parseIcon(iconUnparsed);
    const displayLabel = !icon || (icon && hidden);
    const labelStyle = {
        ...(selected && !hidden ? selectedOverrides : {}),
        ...(hidden && !icon ? labelWithoutIconOverrides : {}),
    };
    const iconStyle = {
        fontSize: 22,
        ...(selected && !hidden ? selectedOverrides : {}),
    };
    const rippleRef = useRef(null);
    return (<div ref={containerRef} onClick={onClick} onMouseEnter={onMouseEnter} style={{ zIndex: 1400 }} id={id}>
      {icon && (<IconButton tooltip={hidden ? "" : title} disabled={hidden} style={iconStyle} square {...icon}>
          {icon.icon}
        </IconButton>)}
      {displayLabel && (<Label tabIndex={0} component="a" 
        // @ts-ignore
        href="javascript:undefined" style={labelStyle} onFocus={(event) => rippleRef.current?.start?.(event)} onBlur={(event) => rippleRef.current?.stop?.(event)}>
          {title}
          <Icon>expand_more</Icon>
          <TouchRipple ref={rippleRef}/>
        </Label>)}
    </div>);
};
export default TopMenuLabel;
